query GetFormLocations($formId: ID!) {
    form(id: $formId) {
        id
        locations {
            url
            submissionsCount
            lastSubmissionDate
            conversionRate
        }
    }
}
